export default __webpack_public_path__ + "static/media/dropbox.56e3d9cc.svg";